/**
 * ErrorBoundaryAlert
 */
import React from 'react';
import { Message } from 'semantic-ui-react';

const ErrorBoundaryAlert = () => (
    <Message negative>
        Something went wrong. The Orchard Hand team have been notified about
        this issue and will take a look at it shortly
    </Message>
);

export default ErrorBoundaryAlert;
